export default "__VITE_ASSET__Ce$_nW41__"